import { config } from './config.js';

/**
 * The unauthenticated Watch calls (spec 9.2). No Authorization header, no
 * cookies, never cached. Resolves with the status and the parsed body for
 * every HTTP answer, so the page can show the generic states; rejects only
 * on a network failure. The token goes only in the POST body: never in the
 * path, a query string or a header.
 */
export async function postPublic(path, body) {
  const res = await fetch(`${config.apiUrl}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'omit',
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
  });
  const text = await res.text();
  let parsed = null;
  try { parsed = text ? JSON.parse(text) : null; } catch { parsed = null; }
  return { status: res.status, body: parsed };
}
